module.exports = __webpack_public_path__ + "static/media/oracle_logo.ba87c66f.png";